import { render, staticRenderFns } from "./ChefReview.vue?vue&type=template&id=7eb1c1fa&"
import script from "./ChefReview.vue?vue&type=script&lang=js&"
export * from "./ChefReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports